<template>
  <!--
    1.评标结果和采购公告 更多 列表
    2.市场动态和价格信息 更多 列表
    3.其他（工作动态、供应商推荐和通知公告） 更多  列表
    （调用接口不一致，分三个列表页）
  -->
  <noticeViewAllList
    v-if="
      source === '-1' ||
        source === '0' ||
        source === '2' ||
        source === '3' ||
        source === '10' ||
        source === '11' ||
        source === '12' ||
        source === '13' ||
        source === '14' ||
        source === '15' ||
        source === '16' ||
        source === '17' ||
        source === '18' ||
        source === '19' ||
        source === '20'
    "
    :currBreadCrumb="currBreadCrumb"
    :source="source"
    :activeName="activeName"
    :interfaceType="interfaceType"
    :activeIndex="activeIndex"
  ></noticeViewAllList>
  <market-dynamic-and-price-info-list
    v-else-if="
      source === '1' || source === '4' || source === '5' || source === '6'
    "
    :source="source"
    :curr-bread-crumb="currBreadCrumb"
    :interfaceTypeValue="interfaceType"
    :activeIndex="activeIndex"
  ></market-dynamic-and-price-info-list>
  <listNew
    v-else-if="
      source === announcementPageSource.overseasZone ||
        source === announcementPageSource.JCCG ||
        source === announcementPageSource.JGFA ||
        source === announcementPageSource.JCKJXY ||
        source === announcementPageSource.WZJCML ||
        source === announcementPageSource.CGGLZD ||
        source === announcementPageSource.SFWB ||
        source === announcementPageSource.NMQYXX ||
        source === announcementPageSource.HJQK ||
        source === announcementPageSource.ZCFG ||
        source === announcementPageSource.ZDLC ||
        source === announcementPageSource.HTFB ||
        source === announcementPageSource.ZSGL ||
        source === announcementPageSource.GLTX ||
        source === announcementPageSource.HYWZ ||
        source === announcementPageSource.HYXW ||
        source === announcementPageSource.SCHQ ||
        source === announcementPageSource.JGXX ||
        source === announcementPageSource.FXBG ||
        source === announcementPageSource.GYLGLBZJLXX ||
        source === announcementPageSource.JCZJCYMD
    "
    :currBreadCrumb="currBreadCrumb"
    :callInterface="callInterface1"
    :source="source"
    :activeIndex="activeIndex"
  ></listNew>
  <!-- 供应商 -->
  <supList
    v-else-if="source === announcementPageSource.JTGYSML"
    :currBreadCrumb="currBreadCrumb"
    :callInterface="callInterface2"
    :source="source"
  ></supList>
  <!-- 交流论坛 -->
  <exchangeForum
    v-else-if="source === announcementPageSource.exchangeForum"
    :curr-bread-crumb="currBreadCrumb"
    :activeIndex="activeIndex"
  >
  </exchangeForum>
  <list
    v-else
    :currBreadCrumb="currBreadCrumb"
    :callInterface="callInterface"
    :source="source"
  ></list>
</template>

<script>
import {
  queryPublishedNoticeList,
  selectNoticeList,
  querySupplierDirectoryList
} from "@/app/shop/api/shopping";
import list from "@/app/shop/components/list.vue";
import listNew from "@/app/shop/components/listNew.vue";
import supList from "@/app/shop/components/supList.vue";
import noticeViewAllList from "@/app/shop/components/noticeViewAllList.vue";
import exchangeForum from "@/app/shop/components/exchangeForum.vue";
import { announcementPageSource } from "@/setting/setting";
import MarketDynamicAndPriceInfoList from "../components/marketDynamicAndPriceInfoList";
export default {
  name: "announcementsList",
  components: {
    MarketDynamicAndPriceInfoList,
    list,
    listNew,
    supList,
    noticeViewAllList,
    exchangeForum
  },
  data() {
    return {
      announcementPageSource: announcementPageSource,
      currBreadCrumb: [],
      callInterface: queryPublishedNoticeList,
      callInterface1: selectNoticeList,
      callInterface2: querySupplierDirectoryList,
      source: this.$route.query.source,
      type: this.$route.query.type,
      activeName: this.$route.query.activeName,
      interfaceType: this.$route.query.interfaceType,
      activeIndex: this.$route.query.activeIndex
    };
  },
  activated() {
    this.init();
  },
  deactivated() {
    this.currBreadCrumb = [];
  },
  methods: {
    init() {
      console.log(this.source, "source");
      switch (this.source) {
        case "-1":
          this.currBreadCrumb.push({ title: "通知公告" });
          break;
        case "0":
          this.currBreadCrumb.push({ title: "工作动态" });
          break;
        case "1":
          this.currBreadCrumb.push({ title: "价格指导" });
          break;
        case "2":
          this.currBreadCrumb.push({
            title: "采购公告"
          });
          break;
        case "3":
          this.currBreadCrumb.push({ title: "评标公示" });
          break;
        case "4":
          this.currBreadCrumb.push({ title: "行业要闻" });
          break;
        case "5":
          this.currBreadCrumb.push({ title: "市场行情" });
          break;
        case "6":
          this.currBreadCrumb.push({ title: "分析报告" });
          break;
        case "10":
          this.currBreadCrumb.push(
            { title: "采购招标" },
            { title: "采购公告" }
          );
          break;
        case "11":
          this.currBreadCrumb.push(
            { title: "采购招标" },
            { title: "评标公示" }
          );
          break;
        case "12":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "集采成果" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "13":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "集采方案" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "14":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "集采框架协议" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "15":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "物资集采目录" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "16":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "集采专家成员名单" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "17":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "采购管理制度" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "18":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "示范文本" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "19":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "内贸企业信息" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "20":
          this.currBreadCrumb.push(
            { title: "集采展示专栏" },
            { title: "获奖情况" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "21":
          this.currBreadCrumb.push(
            { title: "供应商" },
            { title: "集团供应商名录" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "30":
          this.currBreadCrumb.push(
            { title: "市场动态" },
            { title: "行业新闻" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "31":
          this.currBreadCrumb.push(
            { title: "市场动态" },
            { title: "市场行情" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "32":
          this.currBreadCrumb.push(
            { title: "市场动态" },
            { title: "价格信息" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "33":
          this.currBreadCrumb.push(
            { title: "市场动态" },
            { title: "分析报告" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "27":
          this.currBreadCrumb.push(
            { title: "市场动态" },
            { title: "行业网站" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "22":
          this.currBreadCrumb.push(
            { title: "规章制度" },
            { title: "政策法规" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "23":
          this.currBreadCrumb.push(
            { title: "规章制度" },
            { title: "制度流程" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "24":
          this.currBreadCrumb.push(
            { title: "规章制度" },
            { title: "合同范本" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "25":
          this.currBreadCrumb.push(
            { title: "规章制度" },
            { title: "知识管理" }
          );
          this.callInterface = selectNoticeList;
          break;
        case "26":
          this.currBreadCrumb.push({ title: "管理体系" });
          this.callInterface = selectNoticeList;
          break;
        case "29":
          this.currBreadCrumb.push({ title: "交流论坛" });
          break;
        default:
          this.currBreadCrumb.push({ title: "通知公告" });
          break;
      }
    }
  }
};
</script>

<style scoped></style>
